import { Box, List, styled } from "@mui/material"
import { useEffect, useState } from "react"
import DeviceListItem from "./DeviceListItem"
import FilterSearch from "./FilterSearch/FilterSearch"

const StyledList = styled(List)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  minHeight: 0,
  display: "flex",
  flexDirection: "column"
}))

const StyledBox = styled(Box)(({ theme }) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginTop: theme.spacing(3)
}))

const DeviceList = ({ devices }) => {
  const [sortedDevices, setSortedDevices] = useState(devices)
  const [isSorted, setIsSorted] = useState(false)
  const [searchValue, setSearchValue] = useState("")

  const showByFilter = (filterStatus) => {
    const filteredDevices =
      filterStatus === 0
        ? devices
        : devices.filter((device) =>
            filterStatus === 3 ? device.status === 3 : device.status === 2 || device.status === 1
          )

    setSearchValue("")
    setSortedDevices(filteredDevices)
    setIsSorted(true)
  }

  const searchByString = (str) => {
    setSearchValue(str)

    if (str.length >= 3) {
      const searchedDevices = devices.filter((device) => {
        let found = false
        Object.keys(device).forEach((key) => {
          if (device[key] && device[key].indexOf && device[key].indexOf(str.toUpperCase()) > -1) {
            found = true
          }
        })
        return found
      })

      setSortedDevices(searchedDevices)
      setIsSorted(true)
    } else {
      setSortedDevices(devices)
      setIsSorted(false)
    }
  }

  // small fix to se inital devices without changing it everytime we fetch new data every 5000ms.
  useEffect(() => {
    if (!isSorted) {
      setSortedDevices(devices.sort((a, b) => (a.label > b.label ? 1 : -1)))
    }
  }, [devices, setIsSorted, isSorted])

  return (
    <StyledList
      subheader={
        <FilterSearch
          devices={devices}
          showItemByFilter={showByFilter}
          search={searchByString}
          searchValue={searchValue}
        />
      }>
      <StyledBox>
        {sortedDevices.map((device) => {
          return <DeviceListItem key={device.id} device={device} />
        })}
      </StyledBox>
    </StyledList>
  )
}
export default DeviceList
